namespace $.$$ {

	export class $shm_hitalama_map_widget_float_table_relation_atom extends $.$shm_hitalama_map_widget_float_table_relation_atom {
		item_visible() { return this.value() ? [ this.Item() ] : [] }
		item_label() { return this.dictionary()[ this.value() ] ?? this.value() }
		item_content() { return [ this.item_label() ] }
		option_content( link: string ) { return [ this.dictionary()[ link ] ?? link ] }
		item_current() { return !!this.value() && this.active() === this.value() }
		@ $mol_action
		item_open( next?: Event ) {
			if( next === undefined ) return null
			this.open( this.value() )
			return next
		}
	}

	export class $shm_hitalama_map_widget_float_table_relation_list_checks extends $.$shm_hitalama_map_widget_float_table_relation_list_checks {
		check_title( link: string ) { return this.relation().dictionary()[ link ] ?? link }
		check_content( link: string ) { return this.relation().item_content( link ) }
	}

	export class $shm_hitalama_map_widget_float_table_relation_list extends $.$shm_hitalama_map_widget_float_table_relation_list {
		relation_self() { return this }
		option_ids() { return Object.keys( this.dictionary() ) }
		items() { return this.value().map( link => this.Item( link ) ) }
		item_label( link: string ) { return this.dictionary()[ link ] ?? link }
		item_content( link: string ) { return [ this.item_label( link ) ] }
		item_current( link: string ) { return !!link && this.active() === link }
		@ $mol_action
		item_open( link: string, next?: Event ) {
			if( next === undefined ) return null
			this.open( link )
			return next
		}
	}

}
